import { render } from "./startup-skills-modal.vue?vue&type=template&id=14b77250&ts=true"
import script from "./startup-skills-modal.vue?vue&type=script&lang=ts"
export * from "./startup-skills-modal.vue?vue&type=script&lang=ts"

import "./startup-skills-modal.vue?vue&type=style&index=0&id=14b77250&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__